import { RepositoryFactory } from '@/http/api/RepositoryFactory'
const ContentTypeRepository = RepositoryFactory.get('ContentTypeRepository');

import { DefaultStoreActions } from '@/store/utils/requests'
const { get } = DefaultStoreActions(ContentTypeRepository)

export const STORE_MODULE_NAME = 'content_type';
export const STORE_MODULE_CONFIG =  {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        fetch: get,
    },
}
